"use strict";

import angular from "angular";

/**
 * @component NuEmptyCardInsightCtrl
 * O <nu-empty-card-insight> is a component that is used for show empty insights on Nanda
 */

import template from "./empty-card-insight.component.html";
import "./themes/empty-card-insight.component.scss";
import "./themes/empty-card-insight.component-dark.scss";

class NuEmptyCardInsightCtrl {
    constructor() {
        this.title = "";
        this.description = "";
    }
    $onInit() {
        this.situationInsight = this.onGetSituation();
        this._setTitle();
        this._setDescription();
    }
    _setTitle(type) {
        this.title = "";
    }
    _setDescription(
        visualizationName = this.visualizationName,
        explanation = this.insight.explanation,
        type = this.insight.type
    ) {
        if (visualizationName && explanation && type) {
            const descriptions = {
                health: `
                Para haver algum alerta de saúde, o indicador ${visualizationName} deve estar de acordo com a seguinte 
                regra: 
            <br>
            <br>
                ${explanation}`,
                audit: `
                Para haver algum alerta de auditoria, o indicador ${visualizationName} deve estar de acordo com a seguinte regra: 
            <br>
            <br>
                ${explanation}
                `
            };
            this.description = descriptions[type];
        }
    }
    onGetSituation = (insight = this.insight) => {
        let situation = "";
        if (insight.diagnosis) {
            situation = insight.diagnosis;
        } else {
            situation = insight.class;
        }
        return situation;
    };
}

NuEmptyCardInsightCtrl.$inject = [];

const name = "nuEmptyCardInsight";
const def = {
    bindings: {
        insight: "<",
        visualizationName: "<"
    },
    controller: NuEmptyCardInsightCtrl,
    controllerAs: "emptyCardInsightCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
